require("./subscriptionHistoryDirective");

"use strict";

angular.module('app.myProfile.subscriptionHistory', [
    'app.myProfile.subscriptionHistory.subscriptionHistoryDirective'
]);


// WEBPACK FOOTER //
// ./app.v2/components/myProfile/subscriptionHistory/subscriptionHistory.js